import io from 'socket.io-client';
import { getPermissions } from './RolePermissionService';
import { API_URL } from '../utils/env';
import { updateNotificationsCount, logoutUser } from './ApiUpdateServices';

let socket;
export const socketInitialize = async () => {
  const token = JSON.parse(localStorage.getItem("USER_INFO")).token
console.log("env", process.env.NODE_ENV)
  socket = io.connect(API_URL, {
    query: { token }
  });

  console.log("socket.id", socket.id); // undefined
  socket.on('connect', () => {
    console.log("socket connected !!!!!!!!!!!!!!!!!!!!!", socket);
    console.log("socket.id on connect", socket.id); // 'G5p5...'
  });
  return socket;
}

export const listenSocketEvents = async () => {
  if (!socket || !socket.connected) {
    console.log('socket connection reinitialized');
    await socketInitialize();
  }else {
    console.log("socket already connected !!!!!!!!!!!!!!!!!!!!!");
  }

  // listen event for Role Permission Updates
  socket.on("permissionUpdated", message => {
    // console.log the message for posterity
    console.log('permissionUpdated message done from socket services ' + new Date().toLocaleTimeString() + '>>>>>>>>>>>>>>>>>>>>>>>>>', message);
    // trigger the callback passed in when
    getPermissions();
    // our App component calls connect
  });
   // listen event for Role Permission Updates
   socket.on("notification", message => {
    // console.log the message for posterity
    console.log('Notification sent done from socket services ' + new Date().toLocaleTimeString() + '>>>>>>>>>>>>>>>>>>>>>>>>>', message);
    // trigger the callback passed in when
    updateNotificationsCount();
    // our App component calls connect
  });

  socket.on("socketExpire", message => {
    // console.log the message for posterity
    console.log('User sesion expire sent done from socket services ' + new Date().toLocaleTimeString() + '>>>>>>>>>>>>>>>>>>>>>>>>>', message);
    logoutUser();
  });
  return true;
}


export const socketDisconnect = () => {
  if (socket && socket.connected) {
    socket.disconnect();
    console.log("socket disconnected", socket)
  }
}


export { socket };